import { BookerSkeleton as NativeBookerSkeleton } from '@duda-co/booking/preview';
import React, { useMemo } from 'react';
import {
    LazyNativeBookerWrapper,
    NativeBooker,
} from '../../../LazyNativeBooker';
import { toNativeBookerProps } from '../../../nativeBookerAdapter';
import type { BookerStepViewProps } from './bookerStepView';
import NativeBookingMarkup from './NativeBookingMarkup';

const NativeBookerStep = ({
    shouldRenderBooker,
    shouldRenderLoadingSkeleton,
    shouldRenderBookingMarkup,
    onBookerStateChange,
    bookerKey,
    clientId,
    apiUrl,
    siteLocale,
    isBookingDryRun,
    commonBookerProps,
}: BookerStepViewProps) => {
    const nativeBookerProps = useMemo(
        () => toNativeBookerProps(commonBookerProps),
        [commonBookerProps]
    );

    return (
        <>
            {shouldRenderBooker && (
                <div className='native-booker-atom'>
                    <LazyNativeBookerWrapper
                        clientId={clientId}
                        apiUrl={apiUrl}
                        language={siteLocale}
                    >
                        <NativeBooker
                            key={bookerKey}
                            isBookingDryRun={isBookingDryRun}
                            onBookerStateChange={onBookerStateChange}
                            {...nativeBookerProps}
                        />
                    </LazyNativeBookerWrapper>
                </div>
            )}
            {shouldRenderLoadingSkeleton && (
                <div className='native-booker-atom native-booker-skeleton'>
                    <NativeBookerSkeleton />
                </div>
            )}
            {shouldRenderBookingMarkup && <NativeBookingMarkup />}
        </>
    );
};

export default NativeBookerStep;
